type RequestType = string;

const currentRequests: Record<RequestType, AbortController> = {};

export const cancelExistingRequests = (requestType: RequestType) => {
  if (currentRequests[requestType]) {
    currentRequests[requestType].abort();
    delete currentRequests[requestType];
  }
};

const registerAbortController = (
  requestType: RequestType,
  abortController: AbortController
) => {
  currentRequests[requestType] = abortController;
};

export const switchToNewRequest = (requestType: RequestType) => {
  cancelExistingRequests(requestType);
  const abortController = new AbortController();
  registerAbortController(requestType, abortController);
  return abortController;
};

export const completeRequest = (requestType: RequestType) => {
  if (currentRequests[requestType]) {
    delete currentRequests[requestType];
  }
};

export const completeRequestOperator = (requestType: RequestType) => {
  return () => completeRequest(requestType);
};

export const getRequestAborter = (requestType: RequestType) => ({
  switchToNewRequest: () => switchToNewRequest(requestType),
  completeRequest: () => completeRequest(requestType),
  completeRequestOperator: () => completeRequestOperator(requestType)
});
